/**
 * LanguageToggle — switch between English, Hindi and Bhojpuri for agent voice.
 *
 * Props:
 *   value    — "en" | "hi" | "bho"
 *   onChange — (lang: string) => void
 *   langs    — optional subset of language codes to show (defaults to all three)
 */
const ALL_LANGS = [
  { code: "en",  label: "English"    },
  { code: "hi",  label: "हिंदी"      },
  { code: "bho", label: "भोजपुरी"   },
];

export default function LanguageToggle({ value, onChange, langs }) {
  const options = langs ? ALL_LANGS.filter((l) => langs.includes(l.code)) : ALL_LANGS;
  return (
    <div className="flex items-center gap-1 p-1 rounded-full border border-white/15"
         style={{ background: "rgba(255,255,255,0.04)" }}>
      {options.map(({ code, label }) => (
        <button
          key={code}
          onClick={() => onChange(code)}
          className="font-mono-kl text-[11px] uppercase tracking-widest px-4 py-1.5 rounded-full transition-all"
          style={{
            background: value === code ? "var(--kl-red)" : "transparent",
            color: value === code ? "#fff" : "rgba(255,255,255,0.45)",
            border: "none",
            cursor: "pointer",
            fontWeight: value === code ? 600 : 400,
          }}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
